import { Controller } from 'stimulus';

import RailsApi from '../models/rails-api';

export default class extends Controller {
  static targets = ['content', 'container', 'main'];

  contentTarget: HTMLElement;

  containerTarget: HTMLElement;

  mainTarget: HTMLElement;

  close() {
    this.containerTarget.classList.remove('is-open');
    this.contentTarget.innerHTML = '';
  }

  clickAway(e: Event) {
    if (
      !this.contentTarget.contains(e.target as HTMLInputElement) &&
      this.containerTarget.classList.contains('is-open')
    ) {
      this.close();
    }
  }

  async open(e: Event) {
    this.legacyShowSpinner();
    await this.fetchModalContent((e.target as HTMLElement).dataset.href!);
  }

  hideSpinner() {
    if (this.spinner && this.spinner.parentNode) {
      this.spinner.parentNode.removeChild(this.spinner);
    }
  }

  legacyShowSpinner() {
    if (this.legacySpinner) {
      const spinnerNode = document.createElement('div');
      spinnerNode.innerHTML = this.legacySpinner.innerHTML;
      this.mainTarget.appendChild(spinnerNode);
    }
  }

  get legacySpinner() {
    return document.getElementById('loadingSpinnerTemplate');
  }

  get spinner() {
    return this.mainTarget.querySelector('.LoadingSpinner-background');
  }

  async fetchModalContent(route: string) {
    await RailsApi.fetch(route)
      .then(response => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
        this.hideSpinner();
        return Promise.reject(new Error(response.statusText));
      })
      .then(response => response.text())
      .then(html => {
        const htmlFragment = document.createRange().createContextualFragment(html);
        this.contentTarget.replaceChildren(htmlFragment);
        this.containerTarget.classList.add('is-open');
        this.containerTarget.dispatchEvent(new CustomEvent('fetch-modal.contentLoaded', { bubbles: true }));
        this.hideSpinner();
      });
  }
}
